import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import {FaMedium,FaGithub, FaLinkedin , FaTwitter} from "react-icons/fa";

import "./footer.css";
const Footer = () => {
  return (
    <Box height={"100%"} width={"100%"}>
        <footer style={{backgroundColor:"#001C30" , width:"100%"}}>
        <Box justifyContent={'flex-start'}>
        <Text children="THANKS FOR STOPPING BY." color={"white"} fontSize={"sm"}  paddingLeft={"5"} paddingTop={"3"} letterSpacing={2}/>
        {/* <Text children="In the end, it all makes sense."color={"white"} fontSize={"xl"} fontWeight={'bold'} paddingLeft={"5"} paddingTop={"3"} letterSpacing={3}/> */}
        </Box>
        <HStack justifyContent={"flex-end"} spacing={"10"} paddingRight={"5"} paddingBottom={"2"}>
            <span><a href="https://www.linkedin.com/in/avibhawnani/"><FaLinkedin size={24}  color='white'></FaLinkedin></a></span>
            <span><a href="https://twitter.com/avibhawnani"><FaTwitter size={24}  color='white'></FaTwitter></a></span>
            <span><a href='https://github.com/avibhawnani'><FaGithub size={24} color='white'></FaGithub></a></span>
            <span><a href='https://avibhawnani.medium.com/'><FaMedium size={24} color='white' ></FaMedium></a></span>
        </HStack>
        <Text color={"white"} fontSize={"sm"} letterSpacing={2} textAlign={"center"} paddingRight={"5"} paddingBottom={"5"} paddingTop={"5"} >&copy; 2023 | <a href="https://avibhawnani.netlify.app/">Avi Bhawnani</a></Text>
        </footer>
    </Box>
  )
}

export default Footer